import { memo } from 'react'

import ScrollIntoView from '@/components/rundown/ScrollIntoView.jsx'

import { cn } from 'tailwind-variants'

import { useAutoScroll } from '@/features/rundown/auto-scroll.store'
import { useRundownId } from '@/features/rundown/rundown.derived'

/**
 * The "Current cue" line, rendered only for the active row.
 */
export const CueActiveMarker = memo(function CueActiveMarker({
  isFirstCue,
}: {
  isFirstCue: boolean
}) {
  const rundownId = useRundownId()

  const isAutoScrollEnabled = useAutoScroll(rundownId)

  return (
    <>
      <ScrollIntoView
        following={isAutoScrollEnabled}
        marginTop="-110px"
      />
      <div className="relative">
        <span
          className={cn([
            'mt-4 w-full h-1 block bg-[#ef4444] outline-4 outline-black',
            isFirstCue ? 'mb-4' : '',
          ])}
        />
        <span className="absolute -top-1.5 ml-8 text-xs font-bold uppercase text-[#ef4444] bg-black px-2">
          Current cue
        </span>
      </div>
    </>
  )
})
